// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".contract-detail .detail-body[data-v-1c927d67] {\n  padding: 0 0.26667rem;\n  box-sizing: border-box;\n}\n.contract-detail .muted[data-v-1c927d67] {\n  color: #909399;\n}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
